import { styleMaskThemeBackground } from '@/utils/styles';
// eslint-disable-next-line no-restricted-imports -- raw token read kept until this site is moved to theme.semantics
import { DS_COLOR } from '@calm/evexia-design-tokens';
import { Theme } from '@rhg/libs/material';
import { grey } from '@rhg/libs/material/colors';

// Including this value here since Storybook complains about accessing it before initialization when it's within the component file
export const navOffsetPercentPerSide = 2;

export const styleCarouselContainer = {
    display: 'flex',
    height: '100%',
    width: '100%',
    overflowX: 'scroll',
    overflowY: 'hidden',
    gap: {
        xs: '12px',
        md: '16px',
        lg: '24px',
    },
    gridRow: '1 / -1', // Span all grid rows
    gridColumn: '1 / -1', // Span all grid columns
    scrollSnapType: 'x mandatory',

    /* Hide horizontal scrollbar */
    scrollbarWidth: 'none' /* Firefox */,
    msOverflowStyle: 'none' /* IE and Edge */,
    /* Chrome, Safari and Operae */
    '&::-webkit-scrollbar': {
        display: 'none',
        WebkitAppearance: 'none',
    },
};

export const styleOuterCarouselContainer = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
};
export const styleInnerCarouselContainer = {
    display: 'grid',
    gridTemplateRows: (theme: Theme) =>
        `1fr ${theme.semantics.Spacing[40]}px 1fr`, // Position nav arrows
    height: '100%',
    width: '100%',
};
export const styleNavArrowContainer = {
    gridRow: 2,
    width: `calc(100% + ${navOffsetPercentPerSide * 2}%)`,
    marginLeft: `-${navOffsetPercentPerSide}%`,
    maxWidth: '100dvw',
    display: 'flex',
    alignItems: 'center',
    gridColumn: '1',
    transition: 'opacity 200ms ease-in-out',
};

export const styleButton = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: `0px 1px 4px 0px ${DS_COLOR.BLACK_12P}`,
    pointerEvents: 'auto',
    zIndex: (theme: Theme) => theme.zIndex.fab,
    backgroundColor: styleMaskThemeBackground,
    '&:hover, &:focus-visible': {
        backgroundColor: (theme: Theme) =>
            theme.palette.mode === 'dark' ? 'action.hover' : grey[100],
    },
};

export const styleContainerHoverNavDisplay = {
    '&:hover > .navArrowContainer, &:focus-within > .navArrowContainer': {
        opacity: 1,
    },
};
export const styleNavDisplayOnHover = {
    // Keeps this visible to screenreaders
    opacity: 0,
};

export const styleArrowBackIosCorrector = {
    position: 'relative',
    left: (theme: Theme) => `${theme.semantics.Spacing[4]}px`,
};
